import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import "./RecentlyUpdatedSection.scss";
import { SUBGRAPH_URL, EXCLUDED_COLLECTIONS } from "../Market/Market";

const MARKET_V2 = process.env.REACT_APP_MARKETPLACE_ADDRESS_V2?.toLowerCase();

async function fetchAllMarketListings() {
  const PAGE = 1000;
  let all = [];
  let skip = 0;
  while (true) {
    const q = `{listings(where:{active:true},first:${PAGE},skip:${skip}){market token{collection{id}}}}`;
    const res = await fetch(SUBGRAPH_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query: q }),
    });
    const json = await res.json();
    const batch = json.data?.listings || [];
    all = all.concat(batch);
    if (batch.length < PAGE) break;
    skip += PAGE;
  }
  return all;
}

const RecentlyUpdatedSection = ({ title, collections = [] }) => {
  const navigate = useNavigate();
  const [allListings, setAllListings] = useState([]);

  useEffect(() => {
    fetchAllMarketListings().then(setAllListings);
  }, []);

  const v2Ids = useMemo(() => {
    const v2 = new Set();
    for (const l of allListings) {
      const id = l.token?.collection?.id?.toLowerCase();
      if (!id) continue;
      if (l.market?.toLowerCase() === MARKET_V2) v2.add(id);
    }
    return v2;
  }, [allListings]);

  const filteredCollections = useMemo(() => {
    const hasMarketData = allListings.length > 0;
    const visibleCollections = collections.filter(
      (col) => !EXCLUDED_COLLECTIONS.includes(col.id?.toLowerCase()),
    );
    if (!hasMarketData) return visibleCollections;
    return visibleCollections.filter((col) =>
      v2Ids.has(col.id?.toLowerCase()),
    );
  }, [collections, allListings, v2Ids]);

  const handleClick = (item) => {
    navigate(
      `/reproduction/collections?country=Palestine&collection=${item.id}`,
      {
        state: {
          country: "Palestine",
          collectionId: item.id,
        },
      },
    );
  };

  return (
    <section className="recent">
      <div className="recent__container">
        <div className="recent__grid">
          {filteredCollections.map((item, index) => {
            const isOdd = filteredCollections.length % 2 !== 0;
            const isLast = index === filteredCollections.length - 1;

            return (
              <div
                className={`recent__card ${
                  isOdd && isLast ? "recent__card--full" : ""
                }`}
                key={index}
                onClick={() => handleClick(item)}
              >
                <div className="recent__image">
                  <img src={item.image} alt={item.name} />
                  <div className="overlay3">
                    <h3 className="title3">{item.name}</h3>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RecentlyUpdatedSection;
